import { IconButton, Tooltip } from "@mui/material";
import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";
import {
  companyProfileInfoForUser,
  viewCompanyProfileInfoAPICall,
} from "../../../../API/Settings/Company Settings/companySettingsAPI";
import PO from "../../../../Assets/statusRibbon/purchaseorder.png";
import Cancel from "../../../../Assets/statusRibbon/cancel.png";
import Done from "../../../../Assets/statusRibbon/done.png";
import { convertDateFormat, today } from "../../../../Js/Date";
import { useReactToPrint } from "../../../Shared/print/useHtml2PdfPrint";
import ReactToPrint from "../../../Shared/print/ReactToPrint";
import { viewPurchaseOrderSingleView } from "../../../../API/Purchase Manager/NewPurchaseOrder/PurchaseOrder";
import { set_Back_button_action } from "../../../Single Components/listSlice/filterCategorySlice";
import Template1 from "../../SalesNew/SalesOrders/SalesQuotation/Template1";
import Template2 from "../../SalesNew/SalesOrders/SalesQuotation/Template2";
import { getTemplateAPI } from "../../SalesNew/SalesOrders/SalesQuotation/salesQuatationAPI";
import { printSection } from "../../Accounts/PrintComponents/printTemplates/common/enum";
import { InvoiceContent } from "../../Accounts/PrintComponents/printTemplates/common/InvoiceContent";
import ExcelJS from "exceljs";

export const PurchaseOrderSingleView = () => {
  let navigateTo = useNavigate();
  const paymentsPrint = useRef(null);
  const paymentsPrintNew = useRef(null);
  const componentRef = useRef(null);
  const dispatch = useDispatch();
  const decimalPosition = localStorage.getItem("decimalPosition");
  //data of selected List
  const singleViewID = localStorage.getItem("singleViewById");

  const singleList = useSelector(
    (state) => state?.RfqSlice?.purchaseOrderSingleView
  );
  // company details and info
  const companyProfileData = useSelector(
    (state) => state?.companyProfileSlice?.userValue
  );

  const template = useSelector(
    (state) => state?.salesQuatationSlice?.setTemplate
  );

  const formValuesInitialState = {
    status: "",
    companyLogo: "",
    companyName: "",
    companyAddress: "",
    companyContact: "",
    companyTRN: "",

    customerName: "",
    customerAddress: "",
    customerContact: "",

    dateN1: "Quotation Date",
    dateN2: "Expiry Date",

    lpo: "",
    ref: "",
    name: "",
    firstDate: "",
    secondDate: "",

    termsAndCondition: "",

    address: "Vendor ",
    sequence: "PO No",
    subtotal: 0,
    inclusiveTax: 0,
    exclusiveTax: 0,
    total: 0,
    totalAmount: "",
    payTerm: "",
    label: "PURCHASE ORDER",
  };
  const [formValues, setFormValues] = useState(formValuesInitialState);
  const [data, setData] = useState([]);
  const [tax, setTax] = useState([]);
  const [domain, setDomain] = useState("");

  const downloadList = () => {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("Purchase Order");
    sheet.properties.defaultRowHeight = 20;
  
    const titleRow = sheet.addRow(["Purchase Order"]);
    titleRow.font = { size: 15, bold: true };
    sheet.mergeCells("A1:K1");
    titleRow.getCell(1).alignment = {
      vertical: "middle",
      horizontal: "center",
    };
  
    sheet.addRow([`Company: ${formValues.companyName}`]);
    sheet.addRow([`Address: ${formValues.companyAddress}`]);
    sheet.addRow([`Contact: ${formValues.companyContact}`]);
  
    const vendorLabelRow = sheet.addRow(["Vendor Address:"]);
    vendorLabelRow.getCell(1).font = { bold: true };
    sheet.addRow([`Name: ${formValues.customerName}`]);
    sheet.addRow([`Address: ${formValues.customerAddress}`]);
    sheet.addRow([`Contact: ${formValues.customerContact}`]);
  
    const rfqDetailsRow1 = sheet.addRow(["PO No:", formValues.name]);
    const rfqDetailsRow2 = sheet.addRow(["Quotation Date:", formValues.firstDate]);
    const rfqDetailsRow3 = sheet.addRow(["Expiry Date:", formValues.secondDate]);
  
    [rfqDetailsRow1, rfqDetailsRow2, rfqDetailsRow3].forEach(row => {
      row.getCell(1).font = { bold: true };
    });
    const headerRow = sheet.addRow([
      "SI No",
      "Product",
      "Description",
      "Qty",
      "UOM",
      "Rate",
      "Amount",
      "Disc%",
      "VAT",
      "VAT Amount",
      "Net Amount",
    ]);
    const headerFill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFEAEEF9" },
    };  
    const rowFill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFF1F2F5" },
    };
      const totalFill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFE9E9E9" },
    };
    const headerFont = {
      size: 12,
      bold: true,
      color: { argb: "FF000000" },
    };
  
    headerRow.eachCell((cell, colNumber) => {
      cell.fill = headerFill;
      cell.font = headerFont;
      cell.alignment = { vertical: "middle", horizontal: "center" };
    });
  
    data?.forEach((item, index) => {
      const row = sheet.addRow([
        index + 1,
        item.product || '', 
        item?.label || '', 
        item.qty || 0, 
        item.uomName || '', 
        item.unitPrice?.toFixed(decimalPosition) || 0, 
        (item.qty * item.unitPrice)?.toFixed(decimalPosition) || 0, 
        item.discount || 0, 
        item.taxIdList?.map(r => r?.taxName).join(', ') || '', 
        item.taxAmt?.toFixed(decimalPosition) || 0, 
        item.includedPrice === false 
          ? (item.lineTotal + item.taxAmt)?.toFixed(decimalPosition) 
          : item.lineTotal?.toFixed(decimalPosition) 
      ]);
  
      row.eachCell((cell) => {
        cell.fill = rowFill;
        cell.border = {
          bottom: { style: "thin", color: { argb: "FFEDF2F9" } },
        };
        cell.alignment = { horizontal: "center" };
      });
    });
  const totalRow = sheet.addRow([
    "TOTAL", "", "", "", "", "", 
    data?.reduce((total, item) => {
      const qty = typeof item.qty === "number" ? item.qty : 0;
      const unitPrice = typeof item.unitPrice === "number" ? item.unitPrice : 0;
      return total + qty * unitPrice;
    }, 0)?.toFixed(decimalPosition) || 0, 
    "", 
    "", 
    data?.reduce((acc, row) => acc + row?.taxAmt, 0.0)?.toFixed(decimalPosition) || 0,
    data?.reduce((acc, row) => {
      if (row.includedPrice === false) {
        return acc + (row.lineTotal + row.taxAmt);
      } else {
        return acc + row.lineTotal;
      }
    }, 0.0)?.toFixed(decimalPosition) || 0 
  ]);
  
  
  totalRow.eachCell((cell) => {
    cell.fill = totalFill;
    cell.font = { bold: true };
    cell.alignment = { horizontal: "center" };
  });
    
  const summaryRows = [
    ["", "", "", "", "", "", "", "", "", "Sub Total", formValues?.subtotal || 0],
    ["", "", "", "", "", "", "", "", "", "Total Tax Inclusive", formValues?.inclusiveTax || 0],
    ["", "", "", "", "", "", "", "", "", "Total Tax Exclusive", formValues?.exclusiveTax || 0],
    ["", "", "", "", "", "", "", "", "", "Total", formValues?.total || 0]
  ];
  
  summaryRows.forEach(row => {
    const excelRow = sheet.addRow(row);
  
    const labelCell = excelRow.getCell(10);
    labelCell.font = { bold: true };
    labelCell.alignment = { horizontal: "right" };
  
    const valueCell = excelRow.getCell(11);
    valueCell.numFmt = '#,##0.00';
    valueCell.alignment = { horizontal: "right" };
     excelRow.eachCell((cell) => {
        cell.fill = headerFill;
      });
  });
  
    sheet.columns.forEach(column => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: true }, cell => {
        const columnLength = cell.value ? cell.value.toString().length : 0;
        if (columnLength > maxLength) {
          maxLength = columnLength;
        }
      });
      column.width = Math.min(maxLength + 2, 30);
    });
  
    workbook.xlsx.writeBuffer().then(function(data) {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = `Purchase_Order_${formValues.name || 'PO'}.xlsx`;
      anchor.click();
      window.URL.revokeObjectURL(url);
    });
  };

  // api to fetch companyprofile data
  useEffect(() => {
    getTemplateAPI();
    viewPurchaseOrderSingleView({ _id: singleViewID });
  }, []);

  useEffect(() => {
    setFormValues({
      ...formValues,
      status: singleList?.type,
      companyLogo: companyProfileData?.logo || "",
      companyName: companyProfileData?.companyName || "",
      companyAddress: companyProfileData?.companyAddress || "",
      companyContact: companyProfileData?.contactNumber || "",
      companyTRN: companyProfileData?.companyTRN || "",

      ref: singleList?.reference || "",
      lpo: singleList?.LpoNo || "",

      customerName: singleList?.vendorAddress?.vendorName || "",
      customerAddress: singleList?.vendorAddress?.streetName || "",
      customerContact: singleList?.vendorAddress?.mobileNo || "",
      trn: singleList?.vendorAddress?.TRN || "",
      name: singleList?.sequence || "",
      firstDate: singleList?.quotationDate || "",
      secondDate: singleList?.expiryDate || "",
      payTerm: singleList?.PAYMENTTERM || "",

      termsAndCondition: singleList?.termsAndConditions || "",

      subtotal: singleList?.subTotal || 0,
      inclusiveTax: singleList?.totalTaxInclusive || 0,
      exclusiveTax: singleList?.totalTaxExclusive || 0,
      total: singleList?.total || 0,
      totalAmount: singleList?.totalAmount || "",
      qrcodetype: singleList?.qrcodetype || "",
      supplierId: singleList?.supplierId || "",
      db: singleList?.db || "",
      _id: singleList?._id || "",
    });
    setData(singleList?.productInfo);
    setTax(singleList?.taxDetails);
  }, [singleList, companyProfileData]);

  // Extracting domain from location object
  useEffect(() => {
    if (formValues) {
      // const domainAddress = `${window.location.protocol}//${window.location.host}/posReaderPreview?path=admin/viewqrcodedata&db=${element?.db}&vendororcusid=${element?.supplierId}&type=${element?.qrcodetype}&orderId=${element?._id}`;
      let element = formValues;
      const domainAddress = `${window.location.protocol}//${
        window.location.host
      }/posReaderPreview?path=admin/viewqrcodedata&db=${encodeURIComponent(
        element?.db
      )}&vendororcusid=${encodeURIComponent(
        element?.supplierId
      )}&type=${encodeURIComponent(
        element?.qrcodetype
      )}&orderId=${encodeURIComponent(element?._id)}`;
      setDomain(domainAddress);
    }
  }, [formValues]);

  // 🚀 Ultra-Fast Print Function
  const handleFastPrint = async () => {
    // Check if data is available
    if (!data || data.length === 0) {
      console.error('No purchase order data available to print');
      return;
    }

    try {
      console.log('🚀 Starting Ultra-Fast Print - Creating content programmatically');

      // Create purchase order HTML content programmatically
      const createPurchaseOrderHTML = () => {
        const items = data.map((item, index) => `
          <tr>
            <td style="padding: 6px; border: 1px solid #ddd; text-align: center;">${index + 1}</td>
            <td style="padding: 6px; border: 1px solid #ddd;">${item.product || ''}</td>
            <td style="padding: 6px; border: 1px solid #ddd;">${item.label || ''}</td>
            <td style="padding: 6px; border: 1px solid #ddd; text-align: center;">${item.qty || 0}</td>
            <td style="padding: 6px; border: 1px solid #ddd; text-align: center;">${item.uomName || ''}</td>
            <td style="padding: 6px; border: 1px solid #ddd; text-align: right;">${(item.unitPrice || 0).toFixed(decimalPosition || 2)}</td>
            <td style="padding: 6px; border: 1px solid #ddd; text-align: right;">${((item.qty * item.unitPrice) || 0).toFixed(decimalPosition || 2)}</td>
            <td style="padding: 6px; border: 1px solid #ddd; text-align: right;">${(item.discount || 0).toFixed(decimalPosition || 2)}</td>
            <td style="padding: 6px; border: 1px solid #ddd; text-align: center;">${item.taxIdList?.map(r => r?.taxName).join(', ') || ''}</td>
            <td style="padding: 6px; border: 1px solid #ddd; text-align: right;">${(item.taxAmt || 0).toFixed(decimalPosition || 2)}</td>
            <td style="padding: 6px; border: 1px solid #ddd; text-align: right; font-weight: bold;">
              ${item.includedPrice === false 
                ? ((item.lineTotal + item.taxAmt) || 0).toFixed(decimalPosition || 2)
                : (item.lineTotal || 0).toFixed(decimalPosition || 2)
              }
            </td>
          </tr>
        `).join('');

        return `
          <div style="font-family: Arial, sans-serif; padding: 15px; font-size: 11px;">
            <!-- Header -->
            <div style="text-align: center; margin-bottom: 20px;">
              <h1 style="margin: 0; color: #333; font-size: 18px;">PURCHASE ORDER</h1>
              <div style="margin-top: 8px; font-size: 12px;">
                <strong>PO No:</strong> ${formValues.name || formValues.lpo || ''}
              </div>
              <div>
                <strong>Date:</strong> ${formValues.firstDate || ''}
              </div>
              ${formValues.secondDate ? `<div><strong>Expiry Date:</strong> ${formValues.secondDate}</div>` : ''}
            </div>

            <!-- Company Info -->
            <div style="margin-bottom: 20px; display: flex; justify-content: space-between;">
              <div style="width: 48%;">
                <div style="margin-bottom: 10px;">
                  <strong>From:</strong><br>
                  <span style="font-size: 11px;">${formValues.companyName || ''}</span><br>
                  <span style="font-size: 10px;">${formValues.companyAddress || ''}</span><br>
                  <span style="font-size: 10px;">${formValues.companyContact || ''}</span>
                  ${formValues.companyTRN ? `<br><span style="font-size: 10px;">TRN: ${formValues.companyTRN}</span>` : ''}
                </div>
              </div>
              <div style="width: 48%;">
                <div>
                  <strong>To:</strong><br>
                  <span style="font-size: 11px;">${formValues.customerName || ''}</span><br>
                  <span style="font-size: 10px;">${formValues.customerAddress || ''}</span><br>
                  <span style="font-size: 10px;">${formValues.customerContact || ''}</span>
                </div>
              </div>
            </div>

            <!-- Items Table -->
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 15px; font-size: 10px;">
              <thead>
                <tr style="background-color: #f5f5f5;">
                  <th style="padding: 8px 4px; border: 1px solid #ddd; text-align: center; font-size: 10px;">SI No</th>
                  <th style="padding: 8px 4px; border: 1px solid #ddd; text-align: left; font-size: 10px;">Product</th>
                  <th style="padding: 8px 4px; border: 1px solid #ddd; text-align: left; font-size: 10px;">Description</th>
                  <th style="padding: 8px 4px; border: 1px solid #ddd; text-align: center; font-size: 10px;">Qty</th>
                  <th style="padding: 8px 4px; border: 1px solid #ddd; text-align: center; font-size: 10px;">UOM</th>
                  <th style="padding: 8px 4px; border: 1px solid #ddd; text-align: right; font-size: 10px;">Rate</th>
                  <th style="padding: 8px 4px; border: 1px solid #ddd; text-align: right; font-size: 10px;">Amount</th>
                  <th style="padding: 8px 4px; border: 1px solid #ddd; text-align: right; font-size: 10px;">Disc%</th>
                  <th style="padding: 8px 4px; border: 1px solid #ddd; text-align: center; font-size: 10px;">VAT</th>
                  <th style="padding: 8px 4px; border: 1px solid #ddd; text-align: right; font-size: 10px;">VAT Amt</th>
                  <th style="padding: 8px 4px; border: 1px solid #ddd; text-align: right; font-size: 10px;">Net Amt</th>
                </tr>
              </thead>
              <tbody>
                ${items}
              </tbody>
            </table>

            <!-- Totals -->
            <div style="text-align: right; margin-bottom: 20px;">
              <div style="font-size: 11px;"><strong>Subtotal:</strong> ${(formValues.subtotal || 0).toFixed(decimalPosition || 2)}</div>
              <div style="font-size: 11px;"><strong>Inclusive Tax:</strong> ${(formValues.inclusiveTax || 0).toFixed(decimalPosition || 2)}</div>
              <div style="font-size: 11px;"><strong>Exclusive Tax:</strong> ${(formValues.exclusiveTax || 0).toFixed(decimalPosition || 2)}</div>
              <div style="font-size: 14px; margin-top: 8px; font-weight: bold;"><strong>Total Amount:</strong> ${(formValues.total || 0).toFixed(decimalPosition || 2)}</div>
            </div>

            <!-- Additional Info -->
            <div style="margin-bottom: 15px; font-size: 10px;">
              ${formValues.ref ? `<div><strong>Reference:</strong> ${formValues.ref}</div>` : ''}
              ${formValues.payTerm ? `<div><strong>Payment Terms:</strong> ${formValues.payTerm}</div>` : ''}
            </div>

            <!-- Terms -->
            <div style="margin-top: 30px; border-top: 1px solid #ddd; padding-top: 15px;">
              <h3 style="margin: 0 0 10px 0; font-size: 12px;">Terms & Conditions</h3>
              <p style="margin: 0; font-size: 10px; line-height: 1.4;">${formValues.termsAndCondition || ''}</p>
            </div>
          </div>
        `;
      };

      const purchaseOrderHTML = createPurchaseOrderHTML();
      
      // Create print window with fast mode styles
      const printWindow = window.open('', '_blank', 'width=800,height=600');
      
      if (!printWindow) {
        console.error('Failed to open print window');
        return;
      }

      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>Purchase Order - Fast Print</title>
          <style>
            /* Fast Print CSS - Optimized for speed */
            body { 
              margin: 0; 
              padding: 10mm; 
              font-family: Arial, sans-serif;
              font-size: 12px;
              line-height: 1.4;
            }
            table {
              page-break-inside: avoid;
              break-inside: avoid-page;
            }
            tr { 
              page-break-inside: avoid;
            }
            /* Natural pagination - minimal restrictions */
            @media print { 
              body { margin: 0; padding: 10mm; }
              /* Only prevent row breaks, let everything else flow naturally */
              tr { 
                page-break-inside: avoid;
              }
              /* Allow table headers to repeat on new pages */
              thead { 
                display: table-header-group;
              }
            }
          </style>
        </head>
        <body>
          ${purchaseOrderHTML}
          <script>
            window.onload = function() {
              setTimeout(() => {
                window.print();
                window.close();
              }, 500);
            }
          </script>
        </body>
        </html>
      `);

      printWindow.document.close();
      console.log('✅ Ultra-Fast Print initiated successfully');

    } catch (error) {
      console.error('❌ Error in fast print:', error);
    }
  };

  return (
    <div
      className="main-container"
      style={{ backgroundColor: "unset", padding: "0" }}
    >
      <style>
        {`
          @media print {
            /* Hide all UI controls and navigation */
            .first-div-container,
            .MuiIconButton-root,
            .printer-div,
            .edit-icon1,
            .bi-share,
            .bi-arrow-down-circle,
            .bi-printer,
            .MuiTooltip-root,
            .main-container {
              display: none !important;
            }
            
            /* Show only the print content */
            body {
              margin: 0 !important;
              padding: 10mm !important;
            }
          }
        `}
      </style>
      <div
        className="first-div-container"
        style={{ backgroundColor: "white", justifyContent: "space-between" }}
      >
        {/* <div className="post-ribbon">
          {formValues?.status === "PURCHASE ORDER" && <img src={PO} alt="" />}
          {formValues?.status === "DONE" && <img src={Done} alt="" />}
          {formValues?.status === "CANCEL" && <img src={Cancel} alt="" />}
        </div> */}
        <div style={{ display: "flex", gap: "8px" }}>
          <Tooltip title="Edit">
            <IconButton>
              <i
                class="bi bi-pencil-square edit-icon1"
                onClick={() =>
                  navigateTo(
                    "/userdashboard/purchaseManager/CreateNewPurchaseOrder"
                  )
                }
              ></i>
            </IconButton>
          </Tooltip>
          <h3>
            <span
              style={{ fontSize: "medium", color: "black", cursor: "pointer" }}
              onClick={() => {
                navigateTo("/userdashboard/purchaseManager/NewPurchaseOrder");
                dispatch(
                  set_Back_button_action({ backButtonClickAction: true })
                );
              }}
            >
              Purchase Order &gt;
            </span>
            <span style={{ fontSize: "medium", paddingLeft: "8px" }}>
              {formValues?.name}
            </span>
          </h3>
        </div>
        {/* <ReactToPrint
          trigger={() => (
            <IconButton className="printer-div">
              <i style={{ color: "black" }} class="bi bi-printer"></i>
            </IconButton>
          )}
          content={() => paymentsPrint}
        /> */}
        <div>
          <Tooltip title="Share">
            <IconButton>
              <i
                className="bi bi-share"
                style={{
                  backgroundColor: "#9797e9",
                  color: "white",
                  fontSize: "medium",
                  padding: "8px",
                  borderRadius: "2px",
                }}
              ></i>
            </IconButton>
          </Tooltip>

          {/* <ReactToPrint
            trigger={() => (
              <IconButton className="printer-div" style={{ padding: "1px" }}>
                <i
                  style={{
                    color: "white",
                    backgroundColor: " #d787e7",
                    fontSize: "medium",
                    padding: "8px",
                    borderRadius: "2px",
                  }}
                  className="bi bi-printer"
                ></i>
              </IconButton>
            )}
            content={() => paymentsPrintNew.current}
          /> */}
          <IconButton 
              className="printer-div" 
              style={{ padding: "1px" }}
              onClick={handleFastPrint}
              title="Fast Print"
            >
              <i
                style={{
                  color: "white",
                  backgroundColor: " #d787e7",
                  fontSize: "medium",
                  padding: "8px",
                  borderRadius: "2px",
                }}
                className="bi bi-printer"
              ></i>
            </IconButton>

          <Tooltip title="Download">
            <IconButton onClick={downloadList}>
              <i
                className="bi bi-arrow-down-circle"
                style={{
                  backgroundColor: "rgb(255 118 133 / 69%)",
                  color: "white",
                  fontSize: "medium",
                  padding: "8px",
                  borderRadius: "2px",
                }}
              ></i>
            </IconButton>
          </Tooltip>
        </div>
      </div>
      {/* <hr className="line" /> */}
      <div
        style={{
          backgroundColor: "white",
          height: "84vh",
          marginTop: "4px",
          position: "relative",
        }}
      >
        <div className="second-main-container">
          <div className="post-ribbon" style={{ right: "0px", top: "0px" }}>
            {formValues?.status === "PURCHASE ORDER" && <img src={PO} alt="" />}
            {formValues?.status === "DONE" && <img src={Done} alt="" />}
            {formValues?.status === "CANCEL" && <img src={Cancel} alt="" />}
          </div>
          <div className="left-side-div">
            <img src={formValues?.companyLogo} alt="" />
            <p>{formValues?.companyName}</p>
            <p>{formValues?.companyAddress}</p>
            <p>{formValues?.companyContact}</p>

            <h1 className="vendor-head">Vendor Address</h1>
            <p>{formValues?.customerName}</p>
            <p>{formValues?.customerContact}</p>
            {/* <p>--</p>
          <p>--</p> */}
          </div>
          <div className="right-side-div">
            <h1>Purchase Order</h1>
            <p>/{formValues?.name}</p>

            <div className="date-div">
              <p>
                <span class="date-container-single">Date:</span>
                {formValues?.firstDate}
              </p>
              {/* <p>Order Date:{formValues?.secondDate} </p> */}
            </div>
          </div>
        </div>

        <div className="Table-container">
          <div className="Table-data" style={{ maxHeight: "50vh" }}>
            <table>
              <thead>
                <tr style={{ backgroundColor: "#eaeef9" }}>
                  <th>SI NO</th>
                  <th>PRODUCT</th>
                  <th>DESCRIPTION</th>
                  <th>QTY</th>
                  <th>UOM</th>
                  <th>RATE</th>
                  <th>AMOUNT</th>
                  <th>DISC%</th>
                  <th>VAT </th>
                  <th>VAT AMOUNT</th>
                  <th>NET AMOUNT</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((item, index) => (
                  <tr
                    key={index}
                    style={{
                      backgroundColor: index % 2 === 0 ? "#f1f2f5" : "white",
                    }}
                  >
                    <td>{index + 1}</td>
                    <td>{item.product}</td>
                    <td>{item?.label}</td>
                    <td>{item.qty}</td>
                    <td>{item.uomName}</td>
                    <td>{item.unitPrice?.toFixed(decimalPosition)}</td>
                    <td>
                      {(item.qty * item.unitPrice)?.toFixed(decimalPosition)}
                    </td>
                    <td>{item.discount}%</td>
                    <td>
                      {item.taxIdList?.map((r, i) => (
                        <p
                          key={i}
                          className="tax"
                          style={{ margin: "1px", border: "none" }}
                        >
                          {r?.taxName}
                        </p>
                      ))}
                    </td>
                    <td>{item.taxAmt?.toFixed(decimalPosition)}</td>
                    <td>
                      {item.includedPrice === false
                        ? (item.lineTotal + item.taxAmt)?.toFixed(
                            decimalPosition
                          )
                        : item.lineTotal?.toFixed(decimalPosition)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div
            style={{
              backgroundColor: "#e9e9e9",
              display: "flex",
              textAlign: "end",
              paddingInline: "5%",
              width: "85%",
            }}
          >
            <p style={{ margin: "0" }}>Total</p>
            {data && data.length > 0 && (
              <p
                style={{
                  width: "53%",
                  margin: "0",
                  fontSize: "smaller",
                  fontWeight: "600",
                }}
              >
                {" "}
                {data
                  ?.filter((obj) => obj?.line_type === "lines")
                  ?.reduce((total, item) => {
                    const qty = typeof item.qty === "number" ? item.qty : 0; // Check if item.qty is a number, otherwise default to 0
                    const unitPrice =
                      typeof item.unitPrice === "number" ? item.unitPrice : 0; // Check if item.unitPrice is a number, otherwise default to 0
                    return total + qty * unitPrice;
                  }, 0)
                  ?.toFixed(decimalPosition)}
              </p>
            )}

            <p
              style={{
                width: "28%",
                margin: "0",
                fontSize: "smaller",
                fontWeight: "600",
              }}
            >
              {" "}
              {data
                ?.filter((obj) => obj?.line_type === "lines")
                ?.reduce((acc, row) => acc + row?.taxAmt, 0.0)
                ?.toFixed(decimalPosition)}
            </p>
            <p
              style={{
                width: "17%",
                padding: "3px",
                margin: "0",
                fontSize: "smaller",
                fontWeight: "600",
              }}
            >
              {data
                ?.filter((obj) => obj?.line_type === "lines")
                ?.reduce((acc, row) => {
                  if (row.includedPrice === false) {
                    return acc + (row.lineTotal + row.taxAmt);
                  } else {
                    return acc + row.lineTotal;
                  }
                }, 0.0)
                ?.toFixed(decimalPosition)}
            </p>
          </div>
          <div
            className="last-total-div"
            style={{ width: "85%", padding: "18px 32px" }}
          >
            <div className="sub-total">
              <h1>Sub Total</h1>
              {formValues?.inclusiveTax > 0 && <p>Total tax Inclusive</p>}
              {formValues?.exclusiveTax > 0 && <p>Total tax Exclusive</p>}
              <hr className="line-2" />
              <h1>Total Inc Vat</h1>
            </div>
            <div className="sub-total-amount">
              <h1>{formValues?.subtotal?.toFixed(decimalPosition) || 0}</h1>
              {formValues?.inclusiveTax?.toFixed(decimalPosition) > 0 && (
                <p>{formValues?.inclusiveTax?.toFixed(decimalPosition)}</p>
              )}
              {formValues?.exclusiveTax > 0 && (
                <p>{formValues?.exclusiveTax?.toFixed(decimalPosition)}</p>
              )}
              <hr className="line-3" />
              <h1>{formValues?.total?.toFixed(decimalPosition)}</h1>
            </div>
          </div>
        </div>
      </div>
      {/* payments print view */}
      <div style={{ position: "absolute", left: "-9999px", top: 0 }}>
        <div ref={paymentsPrint}>
          <div className="print-view-top-container">
            <div
              className="print-view-top-left-container"
              style={{ width: "25%" }}
            >
              <p></p>
              <p></p>
            </div>
            <div
              className="print-view-top-middle-container"
              style={{ width: "50%" }}
            >
              {/* <h3>--</h3>

              <h3>--</h3> */}

              <p>Purchase Order</p>
            </div>

            <div
              className="print-view-top-right-container"
              style={{ width: "25%" }}
            >
              <p>{convertDateFormat(today)}</p>
              <p>{""}</p>
            </div>
          </div>

          <div className="second-main-container">
            <div className="left-side-div">
              <img
                src={formValues?.companyLogo}
                alt={formValues?.companyName}
              />
              <p>{formValues?.companyAddress}</p>
              <p>{formValues?.companyContact}</p>

              <h1 className="vendor-head">vendor Address</h1>
              <p>{formValues?.vendorName}</p>
              {/* <p>--</p>
              <p>--</p> */}
            </div>
            <div className="right-side-div">
              <h1>Purchase Order</h1>
              <p>{formValues?.name}</p>
              <div className="date-div">
                <p>
                  <span class="date-container-single">Date:</span>
                  {formValues?.firstDate}
                </p>
                {/* <p>Order Date:{formValues?.secondDate} </p> */}
              </div>
            </div>
          </div>

          <div className="Table-container" style={{ padding: "0px 35px" }}>
            <div className="Table-datas">
              <table style={{ overflow: "none" }}>
                <thead>
                  <tr style={{ backgroundColor: "#eaeef9" }}>
                    <th>No</th>
                    <th>Product</th>
                    <th>QTY</th>
                    <th>Rate</th>
                    <th>Tax%</th>
                    <th>dis%</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr
                      key={index}
                      style={{
                        backgroundColor: index % 2 === 0 ? "#f1f2f5" : "white",
                      }}
                    >
                      <td>{index + 1}</td>
                      <td>{item.product}</td>
                      <td>{item.qty}</td>
                      <td>{item.unitPrice}</td>
                      <td
                        style={{
                          display: "flex",
                          placeContent: "center",
                          marginTop: "10px",
                        }}
                      >
                        {item.taxes?.map((r, i) => (
                          <p key={i} className="tax" style={{ margin: "1px" }}>
                            {r?.amount}%
                          </p>
                        ))}
                      </td>
                      <td>{item.discount}</td>
                      <td>{item.lineTotal?.toFixed(decimalPosition) || 0} </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="last-total-div">
                <div className="sub-total">
                  <h1>Sub Total</h1>
                  {formValues?.inclusiveTax > 0 && <p>Total tax Inclusive</p>}
                  {formValues?.exclusiveTax > 0 && <p>Total tax Exclusive</p>}
                  <hr className="line-2" />
                  <h1>Total</h1>
                </div>
                <div className="sub-total-amount">
                  <h1>{formValues?.subtotal?.toFixed(decimalPosition) || 0}</h1>
                  {formValues?.inclusiveTax?.toFixed(decimalPosition) > 0 && (
                    <p>{formValues?.inclusiveTax?.toFixed(decimalPosition)}</p>
                  )}
                  {formValues?.exclusiveTax > 0 && (
                    <p>{formValues?.exclusiveTax?.toFixed(decimalPosition)}</p>
                  )}
                  <hr className="line-3" />
                  <h1>{formValues?.total?.toFixed(decimalPosition)}</h1>
                </div>
              </div>
            </div>
          </div>
          <div className="terms">
            <h1>Terms & Conditions</h1>
            <hr className="lines" />
          </div>
        </div>
      </div>
      <div style={{ position: "absolute", left: "-9999px", top: 0 }}>
        <div ref={paymentsPrintNew}>
          {/* <Printing /> */}
          <InvoiceContent
            invoiceDetails={{ ...formValues, printSection: printSection.purchaseOrder }}
            ref={componentRef}
            printData={data}
            taxDetails={tax}
            qrData={domain}
          />
        </div>
      </div>
    </div>
  );
};
